"use strict";
exports.__esModule = true;
exports.EstimatedPaymentCategory = void 0;
var EstimatedPaymentCategory;
(function (EstimatedPaymentCategory) {
    EstimatedPaymentCategory["DOWN_PAYMENT"] = "DOWN_PAYMENT";
    EstimatedPaymentCategory["REPAYMENT"] = "REPAYMENT";
    EstimatedPaymentCategory["FIRST_PAYMENT"] = "1ST_PAYMENT";
    EstimatedPaymentCategory["SECOND_PAYMENT"] = "2ND_PAYMENT";
    EstimatedPaymentCategory["MEMBERSHIP_FEE"] = "MEMBERSHIP_FEE";
})(EstimatedPaymentCategory = exports.EstimatedPaymentCategory || (exports.EstimatedPaymentCategory = {}));
